import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { clearPendingRedirect } from '../slices/pendingRedirect';
import { OrderingSelectors } from 'polygon-ordering';

const usePostLoginRedirect = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const member = useAppSelector(state => OrderingSelectors.getMember(state));
  const pendingRedirect = useAppSelector(state => state.pendingRedirect);

  useEffect(() => {
    if (member && member.verified && pendingRedirect) {
      history.push(pendingRedirect);
      dispatch(clearPendingRedirect());
    }
  }, [member?.id, member?.verified, pendingRedirect, dispatch, history]);
};

export default usePostLoginRedirect;
